import React from 'react';
import _flatten from 'lodash/flatten';
import _find from 'lodash/find';
import classnames from 'classnames/bind';
import { connect } from "react-redux";
import { replace, push } from 'react-router-redux';

import FlDialpad from '../../components/FlDialpad';

import SearchRoute from '../../../../Router/SearchRoute';

import styles from './styles.scss';
import AddPaymentMethod from './AddPaymentMethod';
import PickPaymentMethod from './PickPaymentMethod';
import { selectDepositerAccount, setDepositer, setDepositAmount, persistPaymentMethod } from '../../../../store/actions/deposit-modal';
import { fetchAccounts, persistDeposit, setCurrentAccount } from '../../../../store/actions/account';
import DepositForm from './DepositForm';
import PickPaymentMethodType from './PickPaymentMethodType';
import { makePhoneNumberValid } from '../../../../utils';
import Loader from '../../../../components/Loader';
import FlexBox from '../../../../components/FlexBox';
import { useEffect } from 'react';

const cx = classnames.bind(styles);

function DepositModal(props){
    useEffect(() => {
        setCurrentAccount();
        // if(!props.toAccount)
        //     props.onRedirectToHome();
    }, [props.accounts]);

    function setCurrentAccount(){
        if(!props.accounts || !props.accounts.length){
            props.onFetchAccounts();
            return;
        }
        const mainAccount = props.accounts.find(a => a.type.toLowerCase() === 'main');
        const currentAccount = props.toAccount;
        if(!currentAccount || (currentAccount && currentAccount._id !== mainAccount._id))
            props.onSetCurrentAccount(mainAccount._id);
    }

    const handleCancelSelectPaymentMethod = () => {
        props.history.goBack();
        props.onSetDepositor(null);
    }

    const handleAccountSelected = () => {
        const { paymentMethods, depositerAccountId } = props;
        const accounts = _flatten(Object.values(paymentMethods));
        let depositor = _find(accounts, ['_id', depositerAccountId]);
        delete depositor.type;
        delete depositor.default;

        props.onSetDepositor(depositor);
        props.onEnterAmount(true);
        props.onSetDepositAmount(1000);
    }
    
    const closeNumberPad = () => {
        props.history.goBack();
    }

    const handleSetDepositAmount = (amount) => {
        closeNumberPad();
        props.onSetDepositAmount(amount);
    }

    const handlePaymentMethodTypeSelected = (type, details) => {
        if(type == "Card"){
            let depositor = {
                name: "Payment Card",
                // number: "255713122995",
                number: makePhoneNumberValid(props.authUser.phoneNumber).replace("+", ""),
                provider: "card",
                cardName: "Visa Main",
                tempId: "card-yo4ks",
            };

            if(details){
                // delete depositor.cardName;
                depositor = {
                    ...depositor, ...details,
                    tempId: "card-yo4ks",
                };
            }

            // console.log("Card details on form screen: ", depositor);

            props.onSetDepositor(depositor);
            props.onEnterAmount();
            props.onSetDepositAmount(1000);
        }
        else
            props.pickPaymentMethod(type);
    }

    const { depositer, toAccount, depositAmount, paymentMethods, saving, depositerAccountId, 
        authUser, onAddPaymentMethod, onEnterAmount,
        onSelectDepositorAccount, onPersistPaymentMethod,
        onPersistDeposit
    } = props;

    if(!toAccount) return (
        <FlexBox center>
            <Loader />
        </FlexBox>
    );

    return (
        <React.Fragment> 
            <div className={cx('DepositModal')}>
                <div className={cx('form')}>

                    <div className={cx('logoImage circle')}>
                        <svg viewBox="0 0 100 100"><path d="M50.235,38.257c-5.605,0-10.877,2.183-14.841,6.147c-8.183,8.182-8.183,21.498,0.001,29.682  c3.965,3.963,9.233,6.146,14.84,6.146s10.875-2.184,14.841-6.147c3.964-3.964,6.146-9.233,6.146-14.84  c0.001-5.606-2.182-10.877-6.146-14.841C61.112,40.439,55.842,38.257,50.235,38.257z M62.952,71.963  c-3.396,3.396-7.914,5.27-12.719,5.27c-4.804,0-9.32-1.871-12.718-5.269c-7.015-7.015-7.014-18.425-0.001-25.438  c3.396-3.397,7.915-5.27,12.72-5.27c4.804,0.001,9.321,1.871,12.72,5.268c3.397,3.397,5.27,7.916,5.269,12.721  C68.223,64.048,66.352,68.566,62.952,71.963z M61.717,61.953c-0.001-1.6-0.644-3.041-1.925-4.324  c-0.688-0.686-1.396-1.181-2.123-1.486c-0.729-0.306-1.493-0.461-2.297-0.465c-0.803-0.004-1.655,0.124-2.559,0.385  c-0.9,0.261-1.984,0.66-3.248,1.199c-1.264,0.54-2.234,0.803-2.914,0.787c-0.678-0.016-1.305-0.31-1.879-0.882  c-0.618-0.619-0.934-1.272-0.943-1.964c-0.011-0.69,0.291-1.344,0.91-1.963c0.627-0.627,1.352-0.902,2.174-0.827  s1.687,0.565,2.592,1.472l3.271-3.271c-1.472-1.472-3.047-2.292-4.726-2.462s-3.279,0.318-4.805,1.466l-2.455-2.456l-1.811,1.81  l2.422,2.421c-1.215,1.486-1.822,3.045-1.822,4.674c0,1.631,0.637,3.082,1.912,4.357c0.74,0.739,1.496,1.258,2.271,1.557  c0.773,0.298,1.569,0.432,2.393,0.4c0.824-0.029,1.687-0.189,2.586-0.479c0.902-0.291,1.918-0.692,3.052-1.206  c1.131-0.513,2.053-0.759,2.76-0.736c0.711,0.024,1.375,0.344,1.992,0.962c0.598,0.598,0.877,1.264,0.844,1.998  c-0.033,0.735-0.383,1.436-1.047,2.1c-0.8,0.799-1.652,1.174-2.558,1.12c-0.905-0.052-1.808-0.526-2.706-1.426l-3.271,3.271  c1.547,1.548,3.211,2.362,4.991,2.444c1.779,0.083,3.525-0.565,5.238-1.946l2.241,2.241l1.801-1.8l-2.253-2.253  C61.086,65.125,61.715,63.552,61.717,61.953z M13.806,68.621l2.121,2.121l5.77-5.77l-2.121-2.121L13.806,68.621z M79.295,55.622  l2.121,2.121l5.77-5.769l-2.121-2.121L79.295,55.622z M60.939,25.729l-2.121-2.121l-5.769,5.769l2.122,2.121L60.939,25.729z   M94.514,50.686c0-1.92-0.744-3.721-2.094-5.069L63.845,17.041c-1.35-1.35-3.15-2.092-5.069-2.093  c-1.919,0.001-3.721,0.743-5.069,2.093L7.581,63.167c-1.351,1.349-2.095,3.149-2.095,5.07c0,1.918,0.744,3.72,2.095,5.068  l8.746,8.747H8.376v3h77.75v-3H66.122l26.299-26.298C93.77,54.406,94.514,52.605,94.514,50.686z M90.299,53.633l-28.42,28.419  h-41.31L9.701,71.184c-0.783-0.783-1.216-1.83-1.216-2.949c0-1.116,0.433-2.164,1.216-2.947l46.126-46.126  c0.781-0.782,1.83-1.213,2.947-1.213c1.118,0,2.166,0.431,2.947,1.213l28.576,28.576c0.783,0.782,1.215,1.829,1.215,2.948  C91.514,51.803,91.082,52.852,90.299,53.633z"/></svg>
                    </div>
                    
                    <div className={cx('formTitle')}>
                        Deposit Money
                    </div>

                    { !depositer && 
                        <PickPaymentMethodType 
                            paymentMethods={paymentMethods}
                            onTypeSelected={handlePaymentMethodTypeSelected}
                            onAddPaymentMethod={onAddPaymentMethod} 
                        /> 
                    }
                    
                    { depositer &&
                        <DepositForm 
                            authUser={authUser}
                            depositer={depositer}
                            toAccount={toAccount}
                            depositAmount={depositAmount}
                            saving={saving}
                            onPersistDeposit={onPersistDeposit}
                            onChangeAmount={() => onEnterAmount(false)}
                            onChangeDepositer={() => props.onSetDepositor(null)} />
                    }
                </div>

                <SearchRoute path="pickPaymentMethodFor"
                    component={({ value }) => 
                        <PickPaymentMethod 
                            type={value}
                            paymentMethods={paymentMethods}
                            onCancel={handleCancelSelectPaymentMethod}
                            onAddClicked={() => onAddPaymentMethod(value)}
                            onSubmitClicked={handleAccountSelected}
                            depositerAccountId={depositerAccountId}
                            onSelectDepositorAccount={onSelectDepositorAccount} 
                        />
                    }
                />
                
            </div>

            <SearchRoute path="addPaymentMethodFor"
                component={({ value }) => 
                    <AddPaymentMethod 
                        type={value} 
                        onAdd={onPersistPaymentMethod} />
                }
            />

            <SearchRoute path="enterDepositAmount"
                component={() => 
                    <FlDialpad 
                        amount={depositAmount}
                        onComplete={handleSetDepositAmount}
                        onCancel={closeNumberPad} />
                }
            />
        </React.Fragment>
    );
}


function mapDispatchToProps(dispatch){
    return {
        onRedirectToHome: () => {
            dispatch(replace('/'));
        },
        onFetchAccounts: (reloading = false) => {
            dispatch( fetchAccounts(null, reloading) )
        },
        onSetCurrentAccount: (id) => {
            dispatch(setCurrentAccount(id))
        },
        pickPaymentMethod: (selectedPaymentMethod) => {
            const selectedPaymentMethodRoute = {
                hash: '#finlinkModal/DepositMoney',
                search: '?pickPaymentMethodFor=' + selectedPaymentMethod
            };
            dispatch(push(selectedPaymentMethodRoute))
        },
        onAddPaymentMethod: (selectedPaymentMethod) => {
            dispatch(replace({
                hash: '#finlinkModal/DepositMoney',
                search: '?addPaymentMethodFor=' + selectedPaymentMethod
            }))
        },
        onEnterAmount: (shouldReplaceRoute = false) => {
            const newRoute = {
                hash: '#finlinkModal/DepositMoney',
                // search: 'enterDepositAmount=true'
            };

            if(!shouldReplaceRoute)
                dispatch(push(newRoute));
            else
                dispatch(replace(newRoute));
        },
        onCancelEnterAmount: () => {
            dispatch(replace({
                hash: '#finlinkModal/DepositMoney',
                search: ''
            }))
        },
        onSelectDepositorAccount: (accountId) => {
            dispatch(selectDepositerAccount(accountId))
        },
        onSetDepositor: (account) => {
            dispatch(setDepositer(account))
        },
        onSetDepositAmount: (amount) => {
            dispatch(setDepositAmount(amount));
        },
        onPersistPaymentMethod: (paymentMethod) => {
            dispatch(persistPaymentMethod(paymentMethod))
        },
        onPersistDeposit: (toAccount, amount, number, provider) => {
            dispatch(persistDeposit(toAccount, amount, number, provider));
        }
    }
}

function mapStateToProps(state){
    return {
        saving: state.app.formLoading,
        accounts: state.account.accounts,
        toAccount: state.account.currentAccount,
        authUser: state.auth.user,
        paymentMethods: state.auth.user.paymentMethods,
        depositerAccountId: state.depositModal.depositerAccountId,
        depositer: state.depositModal.depositer,
        depositAmount: state.depositModal.amount
    }
}
 
export default connect(mapStateToProps, mapDispatchToProps)(DepositModal);